import moment from 'moment';

export default localeConfig;

function localeConfig($mdDateLocaleProvider) {
    'ngInject';

    $mdDateLocaleProvider.months = [
        'enero', 'febrero', 'marzo',
        'abril', 'mayo', 'junio',
        'julio', 'agosto', 'septiembre',
        'octubre', 'noviembre', 'diciembre'
    ];

    $mdDateLocaleProvider.shortMonths = [
        'ene', 'feb', 'mar',
        'abr', 'may', 'jun',
        'jul', 'ago', 'sep',
        'oct', 'nov', 'dic'
    ];

    $mdDateLocaleProvider.days = [
        'domingo', 'lunes', 'martes', 'miercoles', 'jueves', 'viernes',
        'sabado'
    ];
    $mdDateLocaleProvider.shortDays = [
        'Do', 'Lu', 'Ma', 'Mi', 'Ju', 'Vi', 'Sa'
    ];

    $mdDateLocaleProvider.parseDate = function(dateString) {
        var m = moment(dateString, 'DD/MM/YYYY', true);
        return m.isValid() ? m.toDate() : null;
    };
    $mdDateLocaleProvider.formatDate = function(date) {
        if (date) {
            let m = moment(date);
            return m.isValid() ? m.format('DD/MM/YYYY') : '';
        } else {
            return '';
        }
    };
    $mdDateLocaleProvider.monthHeaderFormatter = function(date) {
        return $mdDateLocaleProvider.shortMonths[date.getMonth()] + ' ' + date.getFullYear();
    };
    $mdDateLocaleProvider.weekNumberFormatter = function(weekNumber) {
        return 'Semana ' + weekNumber;
    };
    $mdDateLocaleProvider.msgCalendar = 'Calendario';
    $mdDateLocaleProvider.msgOpenCalendar = 'Abrir calendario';
}
